import { lt } from 'semver';
import { staticUrl, getAppDownloadUrl, iosDeeplink } from '@/config';
import { Dialog } from '@zyf2e/capui-mobile';
import { env, getAdapter } from '@zyf2e/adapt';

export function downloadApp(url) {
  const ua = navigator.userAgent;
  if (/iPhone|iPad|iPod/.test(ua)) {
    location.href = iosDeeplink;
  } else {
    if (/MicroMessenger/gi.test(ua)) {
      location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.zyhealth.patient';
    } else {
      location.href = 'http://dl.91jkys.com/files/apps/apk/zyhealth.apk';
    }
  }
  // todo  deeplink 跳转
  // const deeplinkUrl = getAppDownloadUrl(url);
  // const ua = navigator.userAgent;
  // if (/iPhone|iPad|iPod/.test(ua)) {
  //   window.openCheckTimer = null;
  //   location.href = deeplinkUrl;
  //   let num = 0;
  //   const [maxNum, time] = [10, 300];
  //   window.openCheckTimer = setInterval(() => {
  //     console.log(document.visibilityState);
  //     num += 1;
  //     if (document.visibilityState === 'hidden') {
  //       clearInterval(window.openCheckTimer);
  //       window.openCheckTimer = null;
  //       console.log('已安装app');
  //     } else if (num > maxNum) {
  //       clearInterval(window.openCheckTimer);
  //       window.openCheckTimer = null;
  //       console.log('未安装app');
  //     }
  //   }, time);
  // } else {
  //   if (/MicroMessenger/gi.test(ua)) {
  //     // todo 引导浏览器打开
  //     // url = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.zyhealth.patient';
  //   } else {
  //     location.href = deeplinkUrl;
  //     // deeplinkUrl
  //     // url = 'http://dl.91jkys.com/files/apps/apk/zyhealth.apk';
  //   }
  // }
}

export async function openUrl(url) {
  if (!env.inAPP && /^native:\/\//.test(url)) {
    try {
      await Dialog.confirm({ message: '请下载智云健康APP' });
      downloadApp(url);
    } catch (error) {
      // do nothing
    }
    return;
  }
  const adapt = getAdapter();

  adapt.open(url);
}

// 单位转换
const preRem = 37.5;
export function px2rem(px, deafultVal) {
  if (px === 0) return px;
  if (!px) return deafultVal;
  return `${Math.round((px / preRem) * 100000) / 100000}rem`;
}

/**
 * 阻止背景滚动
 *
 * @param  Boolean  flag    [是否阻止背景滚动]
 */
export const lockScroll = flag => {
  if (flag) {
    const top = document.documentElement.scrollTop || document.body.scrollTop;
    document.body.style.cssText += `
      position: fixed;
      width: 100vw;
      left: 0;
      top: ${-top}px;
    `;
  } else {
    const top = document.body.style.top;
    document.body.style.cssText += `
      position: static;
    `;
    window.scrollTo(0, Math.abs(parseFloat(top)));
  }
};

// 区分环境区分 智云健康app、微信、非微信外部环境、小程序
export function platformEnv() {
  switch (true) {
    case env.inAPP:
      return 'APP';
    case env.inWechatMiniProgram:
      return 'WechatMiniProgram';
    case env.inWechat:
      return 'Wechat';
    default:
      return 'H5';
  }
}

export const getUrlParam = name => {
  const search = window.location.hash.split('?');
  if (!search[1]) {
    return null;
  }
  const params = search[1].split('&');
  let result = null;
  try {
    params.forEach(val => {
      const arr = val.split('=');
      if (name === arr[0]) {
        result = unescape(arr[1]);
        throw new Error('exist');
      }
    });
  } catch (error) {
    // do nothing
  }
  return result;
};

export function getRouteQuery() {
  const lastIndex = window.location.href.lastIndexOf('?');
  const str = lastIndex === -1 ? '' : window.location.href.slice(lastIndex + 1);
  const query = {};
  if (!str) return query;
  str.split('&').forEach(item => {
    const [k, v] = item.split('=');
    query[k] = v;
  });
  return query;
}

export const compareVersion = (current, latest) => {
  return lt(current, latest);
};
